import {
    FormControlLabel,
    FormGroup,
    Switch as MuiSwitch,
} from "@material-ui/core";
import { createStyles, WithStyles, withStyles } from "@material-ui/core/styles";
import * as React from "react";

// NOTE had to create this special switch
// because the other Switch is tied into
// formik.  This is used on the leads search
// which doesn't use formik.
// Need to find a way to make controls like these
// work even if there is no formik behind it
// hard part is the "checked" property.
const styles = () =>
    createStyles({
        placementStart: {
            marginLeft: 0,
        },
        switch: {
            position: "relative",
            top: "3px",
        },
        negativeBar: {
            backgroundColor: "#ff9394",
        },
        negativeChecked: {
            color: "#ff6c78",
        },
    });

interface Props extends WithStyles<typeof styles> {
    checked?: boolean;
    label?: string;
    dataCy?: string;
    value?: string | boolean;
    labelPlacement?: "bottom" | "top" | "end" | "start" | undefined;
    onSwitchChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
    id?: string;
    disabled?: boolean;
    color?: "primary" | "secondary" | "default";
    negative?: boolean;
    className?: string;
}

export const Switch = withStyles(styles, { name: "RelodeSwitch" })(
    class extends React.Component<Props> {
        render() {
            const {
                classes,
                checked,
                value,
                label,
                labelPlacement,
                onSwitchChange,
                id,
                disabled,
                color,
                className,
                dataCy,
                negative = false,
            } = this.props;

            const muiClasses = negative
                ? {
                      track: classes.negativeBar,
                      checked: classes.negativeChecked,
                  }
                : undefined;

            return (
                <FormGroup row id={`${id}FormGroup`}>
                    <FormControlLabel
                        data-cy={dataCy + "Label"}
                        className={
                            labelPlacement === "start"
                                ? classes.placementStart
                                : undefined
                        }
                        control={
                            <MuiSwitch
                                data-cy={dataCy}
                                classes={muiClasses}
                                checked={checked || false}
                                onChange={onSwitchChange}
                                value={value}
                                className={classes.switch}
                                id={`${id}Input`}
                                disabled={disabled}
                                color={color}
                            />
                        }
                        label={label}
                        labelPlacement={labelPlacement}
                    />
                </FormGroup>
            );
        }
    }
);
